var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "oh text-left" }, [
    _vm.textDisplay.length > 6
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.textDisplay) } })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }